module.exports = "/assets/images/minus-in-circle_70f894.svg";